import React from "react";
import PropTypes from "prop-types";

// @material-ui/core
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import GridItem from "components/Grid/GridItem.jsx";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import WeeklyDeck from "components/WeeklyDeck/WeeklyDeck.jsx";

import AddAlert from "@material-ui/icons/AddAlert";
import SnackbarContent from "components/Snackbar/SnackbarContent.jsx";
import SupersetDashboard from "components/SupersetDashboard/SupersetDashboard.jsx";
import TrainingNote from "components/TrainingNote/TrainingNote.jsx";
import RequestTrainingProgram from "components/RequestTrainingProgram/RequestTrainingProgram.jsx";
import Button from "components/CustomButtons/Button.jsx";
import AddIcon from "@material-ui/icons/Add";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

// authentication
import { withAxios } from "containers/authenticated.js";

// time utilities
import { dayjs } from "utils/time.jsx";

import {
  getNotifications,
  readNotification
} from "services/userDataProvider.js";
import {
  getTrainingNoteConfig,
  createTrainingNote,
  getTrainingNotes
} from "services/userDataProvider.js";
import {
  getUserWidgets,
  updateTrainingPlanForDay
} from "services/dashboardDataProvider.js";
// import { SetupNotification } from "init-firebase.js";

// import { MEDIA_ROOT } from "config.js";

const dashboardStyle = {
  ExternalDashboardContainer: {
    width: "100%"
  },
  ExternalDashboardTitle: {
    width: "100%",
    color: "#235894",
    fontSize: "large",
    paddingTop: "25px",
    paddingBottom: "25px",
    display: "none"
  },
  ExternalDashboardROW: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "warp",
    width: "100%"
  },
  ExternalDashboardChart: {
    width: "100%"
  },
  ExternalDashboardChartTitle: {
    width: "100%",
    color: "#235894",
    fontSize: "large",
    paddingBottom: "25px"
  },
  bannerCard: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "white",
    marginBottom: "24px"
  },
  bannerContent: {
    padding: "40px !important",
    textAlign: "center"
  },
  bannerTitle: {
    fontSize: "1.8rem",
    fontWeight: 600,
    marginBottom: "12px"
  },
  bannerSubtitle: {
    fontSize: "1.1rem",
    marginBottom: "24px",
    opacity: 0.9
  },
  bannerButton: {
    marginTop: "8px"
  }
};

class Dashboard extends React.Component {
  weeklyMileageHistoryRequestId = 0;

  constructor(props) {
    super(props);
    this.state = {
      widgets: [],
      showNotificationsButton: false,
      trainingNoteModalOpen: false,
      trainingNoteConfig: null,
      savingTrainingNote: false,
      saveError: "",
      saveMessage: "",
      dashboardWidgets: [],
      userNotes: [],
      widgetsLoading: false,
      weeklyMileageHistoryLoading: false,
      weeklyMileageHistory: [],
      widgetsError: false,
      weekOffset: 0,
      showAllNotifications: false,
      requestProgramModalOpen: false,
      requestProgramMessage: "",
      addActivity: false,
      selectedActivityName: "",
      selectedActivityDescription: "",
      selectedActivityDate: ""
    };
  }

  componentDidMount() {
    try {
      // SetupNotification(this.props.axios);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log("An error occurred while retrieving token. ", err);
    }
    // eslint-disable-next-line react/prop-types
    getNotifications(this.props.axios).then(data =>
      this.setState({ userNotifications: data.results })
    );

    // Load training note configuration
    this.loadTrainingNoteConfig();

    // Load dashboard widgets
    this.updateUserData(0);
  }

  readNotification = notificationId => () => {
    // console.log("mark read", notificationId)
    readNotification(this.props.axios, notificationId).then(() => {
      this.setState({
        userNotifications: this.state.userNotifications.filter(
          notif => notif.id !== notificationId
        )
      });
    });
  };

  openNotification = notificationData => () => {
    readNotification(this.props.axios, notificationData.id);
    if (notificationData.data) {
      let data = notificationData.data;
      data.link &&
        this.props.history.push(data.link, {
          actor: notificationData.actor_object_id,
          data: data
        });
    }
  };

  loadTrainingNoteConfig = async () => {
    try {
      const { user } = this.props;
      const userId = user && user.id;
      const config = await getTrainingNoteConfig(this.props.axios, userId);
      this.setState({ trainingNoteConfig: config });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Failed to load training note config:", error);
    }
  };

  handleOpenTrainingNote = () => {
    this.setState({
      trainingNoteModalOpen: true,
      addActivity: true,
      saveError: "",
      saveMessage: "",
      selectedActivityName: "",
      selectedActivityDescription: "",
      selectedActivityDate: ""
    });
  };

  handleOpenActivityNoteFromWeeklyDeck = (activity, training) => {
    const metadata = activity && activity.metadata ? activity.metadata : {};
    const distance =
      metadata.distance_km != null
        ? `${metadata.distance_km.toFixed(1)} km`
        : "";
    const timeLabel = metadata.start_time
      ? new Date(metadata.start_time).toLocaleString()
      : "";
    const activityDetails = [distance, timeLabel].filter(Boolean).join(" • ");
    const trainingSummary =
      training && (training.name || training.description)
        ? [training.name, training.description]
            .filter(Boolean)
            .join("\n")
            .trim()
        : "";
    const details = [
      activityDetails ? `Activity: ${activityDetails}` : "",
      trainingSummary ? `Plan:\n${trainingSummary}` : ""
    ]
      .filter(Boolean)
      .join("\n\n");
    const selectedActivityDate = metadata.start_time
      ? new Date(metadata.start_time).toISOString().split("T")[0]
      : "";
    const activityTitle =
      (activity && (activity.description || activity.name)) || "Activity";
    const planTitle = training && training.name ? training.name : "";
    const noteTitle = planTitle
      ? `${activityTitle} - ${planTitle}`
      : activityTitle;

    this.setState({
      trainingNoteModalOpen: true,
      addActivity: false,
      saveError: "",
      saveMessage: "",
      selectedActivityName: noteTitle,
      selectedActivityDescription: details,
      selectedActivityDate
    });
  };

  handleCloseTrainingNote = () => {
    this.setState({
      trainingNoteModalOpen: false,
      addActivity: false,
      saveError: "",
      saveMessage: ""
    });
  };

  handleSaveTrainingNote = async formData => {
    const { user } = this.props;

    // Basic validation
    if (!formData.title && !formData.activity) {
      this.setState({
        saveError: "Please fill in required fields (Title or Activity)"
      });
      return;
    }

    this.setState({ savingTrainingNote: true, saveError: "", saveMessage: "" });

    try {
      const payload = {
        title: formData.title,
        activity_id: formData.activity || 0,
        notes: formData.notes,
        date: formData.date,
        user_id: user && user.id,
        answers: formData.answers
      };

      await createTrainingNote(this.props.axios, payload);
      this.setState({
        savingTrainingNote: false,
        saveMessage: "Training note saved successfully!"
      });

      // Close modal after 2 seconds
      setTimeout(() => {
        this.handleCloseTrainingNote();
      }, 2000);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Failed to save training note:", error);
      this.setState({
        savingTrainingNote: false,
        saveError: "Failed to save training note. Please try again."
      });
    }
  };

  handleToggleEditMode = () => {
    // Not used in create mode, but required by TrainingNote component
  };

  handleOpenRequestProgram = () => {
    this.setState({ requestProgramModalOpen: true, requestProgramMessage: "" });
  };

  handleCloseRequestProgram = () => {
    this.setState({ requestProgramModalOpen: false });
  };

  handleRequestProgramSuccess = formData => {
    // eslint-disable-next-line no-console
    console.log("Training program requested:", formData);
    this.setState({
      requestProgramMessage:
        "Your request has been created. An expert will review it and create the plan for you."
    });
    // Optionally refresh dashboard data
    this.updateUserData(this.state.weekOffset);
  };

  handleToggleNotifications = () => {
    this.setState({
      showAllNotifications: !this.state.showAllNotifications
    });
  };

  handleClearAllNotifications = () => {
    const notificationIds = this.state.userNotifications.map(notif => notif.id);

    // Mark all notifications as read
    Promise.all(
      notificationIds.map(id => readNotification(this.props.axios, id))
    ).then(() => {
      this.setState({
        userNotifications: []
      });
    });
  };

  updateUserData = (weekOffset = this.state.weekOffset, options = {}) => {
    const { user } = this.props;
    const userId = user && user.user_id;

    if (!userId) return;

    this.setState({ widgetsLoading: true, widgetsError: false, weekOffset });

    // Calculate week start and end dates
    const weekStart = dayjs()
      .startOf("week")
      .add(weekOffset || 0, "week");
    const weekEnd = weekStart.add(6, "day");

    // Fetch widgets
    getUserWidgets(this.props.axios, userId, weekOffset, options)
      .then(data => {
        this.setState({
          dashboardWidgets: data.results,
          widgetsLoading: false,
          widgetsError: false
        });
      })
      .catch(err => {
        // eslint-disable-next-line no-console
        console.error("An error occurred while retrieving user widgets. ", err);
        this.setState({
          dashboardWidgets: [],
          widgetsLoading: false,
          widgetsError: true
        });
      });

    // Fetch training notes for the week
    getTrainingNotes(
      this.props.axios,
      userId,
      1,
      100,
      weekStart.format("YYYY-MM-DD"),
      weekEnd.format("YYYY-MM-DD")
    )
      .then(data => {
        this.setState({
          userNotes: data.results || []
        });
      })
      .catch(err => {
        // eslint-disable-next-line no-console
        console.error("An error occurred while retrieving user notes. ", err);
        this.setState({
          userNotes: []
        });
      });

    this.loadWeeklyMileageHistory(weekOffset);
  };

  getWeeklySummaryWidget = widgets => {
    if (!Array.isArray(widgets)) {
      return null;
    }

    return widgets.find(widgetData => {
      const widget = widgetData && widgetData.widget;
      if (!widget) return false;
      return (
        widget.type === "weekly_training_plan_summary" ||
        widget.source === "weekly_training_plan_summary"
      );
    });
  };

  loadWeeklyMileageHistory = async (weekOffset = this.state.weekOffset) => {
    const { user } = this.props;
    const userId = user && user.user_id;

    if (!userId) {
      return;
    }

    const requestId = ++this.weeklyMileageHistoryRequestId;
    const historyLength = 8;
    const offsets = Array.from(
      { length: historyLength },
      (_, index) => weekOffset - (historyLength - 1 - index)
    );

    this.setState({ weeklyMileageHistoryLoading: true });

    const results = await Promise.allSettled(
      offsets.map(offset => getUserWidgets(this.props.axios, userId, offset))
    );

    if (requestId !== this.weeklyMileageHistoryRequestId) {
      return;
    }

    const weeklyMileageHistory = results
      .map((result, index) => {
        if (result.status !== "fulfilled") {
          return null;
        }

        const weekOffsetValue = offsets[index];
        const weekStart = dayjs()
          .startOf("week")
          .add(weekOffsetValue || 0, "week");
        const summaryWidget = this.getWeeklySummaryWidget(result.value.results);
        const metadata =
          summaryWidget && summaryWidget.widget
            ? summaryWidget.widget.metadata
            : null;

        return {
          weekOffset: weekOffsetValue,
          weekLabel: weekStart.format("MMM D"),
          weekRange: `${weekStart.format("MMM D")}`,
          plannedKm:
            metadata && metadata.distance_planned_km != null
              ? metadata.distance_planned_km
              : 0,
          completedKm:
            metadata && metadata.distance_completed_km != null
              ? metadata.distance_completed_km
              : 0
        };
      })
      .filter(Boolean);

    this.setState({
      weeklyMileageHistory,
      weeklyMileageHistoryLoading: false
    });
  };

  handleChangeWeek = delta => {
    this.setState(
      prevState => ({ weekOffset: prevState.weekOffset + delta }),
      () => this.updateUserData(this.state.weekOffset)
    );
  };

  handleGoToCurrentWeek = () => {
    this.updateUserData(0);
  };

  handleForcePerformanceMetricsRefresh = () => {
    this.updateUserData(this.state.weekOffset, {
      forcePerformanceMetrics: true
    });
  };

  handleUpdateTrainingPlanForDay = async ({ day, title, description }) => {
    const { user } = this.props;
    const userId = user && user.user_id;

    await updateTrainingPlanForDay(
      this.props.axios,
      day,
      title,
      description,
      userId
    );
    this.updateUserData();
  };

  renderNotifications() {
    const { userNotifications, showAllNotifications } = this.state;

    if (!userNotifications || userNotifications.length === 0) {
      return null;
    }

    const hasMany = userNotifications.length > 5;
    const notificationsToShow =
      hasMany && !showAllNotifications
        ? userNotifications.slice(0, 2)
        : userNotifications;

    return (
      <GridContainer>
        {/* Action buttons at the top right */}
        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              gap: "8px",
              justifyContent: "flex-end",
              marginBottom: "10px"
            }}
          >
            {hasMany && (
              <Button
                color="info"
                simple
                size="sm"
                onClick={this.handleToggleNotifications}
                style={{
                  padding: "4px 12px",
                  fontSize: "12px",
                  minWidth: "auto"
                }}
              >
                {showAllNotifications
                  ? "Show Less"
                  : `Show All (${userNotifications.length})`}
              </Button>
            )}
            <Button
              color="warning"
              simple
              size="sm"
              onClick={this.handleClearAllNotifications}
              style={{
                padding: "4px 12px",
                fontSize: "12px",
                minWidth: "auto"
              }}
            >
              Clear All
            </Button>
          </div>
        </GridItem>

        {/* Notifications */}
        {notificationsToShow.map(notificationData => {
          return (
            <GridItem
              xs={12}
              sm={12}
              md={12}
              key={`notification-${notificationData.id}`}
            >
              <SnackbarContent
                message={notificationData.description}
                data={notificationData.data}
                icon={AddAlert}
                color={notificationData.level}
                open
                axios={this.props.axios}
                openNotification={this.openNotification(notificationData)}
                closeNotification={this.readNotification(notificationData.id)}
                close
              />
            </GridItem>
          );
        })}
      </GridContainer>
    );
  }

  hasActiveTrainingPlans() {
    const { dashboardWidgets } = this.state;
    if (!Array.isArray(dashboardWidgets) || dashboardWidgets.length === 0) {
      return false;
    }

    const trainingPlansWidgetData = dashboardWidgets.find(widgetData => {
      const widget =
        widgetData && widgetData.widget ? widgetData.widget : widgetData;
      if (!widget) return false;
      return (
        widget.type === "weekly_training_plan_summary" ||
        widget.source === "weekly_training_plan_summary"
      );
    });

    if (!trainingPlansWidgetData) {
      return false;
    }

    const widget =
      trainingPlansWidgetData && trainingPlansWidgetData.widget
        ? trainingPlansWidgetData.widget
        : trainingPlansWidgetData;
    const metadata = widget && widget.metadata ? widget.metadata : null;

    if (!metadata) {
      return false;
    }

    const details = metadata.details;
    const hasDetails =
      details && typeof details === "object" && Object.keys(details).length > 0;
    const hasDistanceSummary =
      metadata.distance_planned_km != null ||
      metadata.distance_completed_km != null;

    return hasDetails || hasDistanceSummary;
  }

  render() {
    // eslint-disable-next-line no-unused-vars
    const { classes } = this.props;
    const {
      trainingNoteModalOpen,
      trainingNoteConfig,
      savingTrainingNote,
      saveError,
      saveMessage,
      dashboardWidgets,
      weekOffset,
      requestProgramModalOpen,
      requestProgramMessage,
      addActivity,
      selectedActivityName,
      selectedActivityDescription,
      selectedActivityDate
    } = this.state;

    const hasNoTrainingPlans = !this.hasActiveTrainingPlans();

    return (
      <GridContainer xs={12} sm={12} md={12}>
        {requestProgramMessage && (
          <GridItem xs={12} sm={12} md={12}>
            <SnackbarContent message={requestProgramMessage} color="success" />
          </GridItem>
        )}

        {this.renderNotifications()}

        {/* Training Program Request Banner */}
        {hasNoTrainingPlans && (
          <GridItem xs={12} sm={12} md={12}>
            <Card className={classes.bannerCard}>
              <CardContent className={classes.bannerContent}>
                <Typography className={classes.bannerTitle}>
                  Ready to Start Your Training Journey?
                </Typography>
                <Typography className={classes.bannerSubtitle}>
                  Get a personalized training program tailored to your goals and
                  fitness level
                </Typography>
                <Button
                  color="info"
                  className={classes.bannerButton}
                  onClick={this.handleOpenRequestProgram}
                >
                  Request Training Program
                </Button>
              </CardContent>
            </Card>
          </GridItem>
        )}

        {/* Add Training Note Button */}
        <GridItem xs={12} sm={12} md={12}>
          <div style={{ padding: "20px 0", textAlign: "right" }}>
            <Button
              color="info"
              onClick={this.handleOpenTrainingNote}
              style={{ marginBottom: "20px" }}
            >
              <AddIcon style={{ marginRight: "8px" }} />
              Add Activity
            </Button>
          </div>
        </GridItem>

        <WeeklyDeck
          dashboardWidgets={dashboardWidgets}
          userNotes={this.state.userNotes}
          weeklyMileageHistory={this.state.weeklyMileageHistory}
          weeklyMileageHistoryLoading={this.state.weeklyMileageHistoryLoading}
          weekOffset={weekOffset}
          widgetsLoading={this.state.widgetsLoading}
          onChangeWeek={this.handleChangeWeek}
          onGoToCurrentWeek={this.handleGoToCurrentWeek}
          onAddActivityNote={this.handleOpenActivityNoteFromWeeklyDeck}
          onUpdateTrainingPlan={this.handleUpdateTrainingPlanForDay}
        />

        <SupersetDashboard
          axios={this.props.axios}
          userId={this.props.user.user_id}
          widgets={this.state.dashboardWidgets}
          widgetsLoading={this.state.widgetsLoading}
          widgetsError={this.state.widgetsError}
          onForcePerformanceMetrics={this.handleForcePerformanceMetricsRefresh}
        />

        {/* Training Note Modal */}
        <TrainingNote
          open={trainingNoteModalOpen}
          onClose={this.handleCloseTrainingNote}
          viewMode="create"
          selectedNote={null}
          onToggleEditMode={this.handleToggleEditMode}
          onSave={this.handleSaveTrainingNote}
          onFormDataChange={() => {}} // Not needed for create mode
          saving={savingTrainingNote}
          saveError={saveError}
          saveMessage={saveMessage}
          config={trainingNoteConfig}
          addActivity={addActivity}
          trainingName={selectedActivityName}
          trainingDescription={selectedActivityDescription}
          trainingDate={selectedActivityDate}
        />

        {/* Request Training Program Modal */}
        <RequestTrainingProgram
          axios={this.props.axios}
          open={requestProgramModalOpen}
          onClose={this.handleCloseRequestProgram}
          onSuccess={this.handleRequestProgramSuccess}
        />
      </GridContainer>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.any,
  user: PropTypes.object,
  axios: PropTypes.func
};

export default withAxios(withStyles(dashboardStyle)(Dashboard));
